export default function replacePath(urlParams: URLSearchParams) {
  // change query string without reload
  if (window.history.replaceState) {
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${
      urlParams.toString().length > 0 ? '?' + urlParams.toString() : ''
    }`;
    window.history.replaceState({ path: newUrl }, '', newUrl);
  }
}
